import I18nCustomTemplate from './src/main.vue';

/* istanbul ignore next */
I18nCustomTemplate.install = function(Vue) {
  Vue.component(I18nCustomTemplate.name, I18nCustomTemplate);
};

export default I18nCustomTemplate;
